import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    reviewContainer: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
    },

    contentLeft: {
        color: "white",
        float: "left",
        fontSize: "20px",
        alignItems: "center",
        display: "flex",
        marginLeft: "2%",
        marginTop: ".5%",
        display: "flex",
        width: "30%",

        justifyContent: "space-between",
    },

    contentRight: {
        marginRight: "2.5%",
        marginTop: "2%",
        color: "white",
        float: "left",
        fontSize: "20px",
        justifyContent: "center",
        textAlign: "center",
    },

    contentCenter: {
        marginTop: "3.5%",
        color: "white",
        fontSize: "20px",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        float: "left",
    },

    btnChallengeDecision: {
        color: "white",
        background: "#3f51b5",
        "&:hover": {
            backgroundColor: "#6877ca",
        },
    },

    contentDecision: {
        float: "left",
        marginLeft: "5%",
        marginTop: "1%",
        justifyContent: "center",
        backgroundColor: "white",
    },
    contentLeftDecisionOverview: {},
    contentLeftIcon: { marginLeft: "5%" },
}));

export { useStyles };
